import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";
import { InputLabel, Select } from "@mui/material";

export const StyledTextField = styled(MuiTextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-radius: 8px;
    }

    &:hover fieldset {
      border-color: rgb(121, 121, 121);
    }

    &.Mui-focused fieldset {
      border-width: 1px;
    }
  }

  & .MuiInputLabel-root {
    color: #a2a2a2;
  }
`;

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgb(121, 121, 121);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  color: #a2a2a2;

  & .Mui-focused {
    color: blue;
  }
`;

export const Title = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #191c1a;
`;

export const Subtitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #0f0f1e99;
`;
